module.exports = __webpack_public_path__ + "img/2.a6e11f77.jpg";